var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"containerTextInOrder"},[_vm._v("تحديث الطلب :")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"hide-default-footer":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }